import { Typography } from '@mui/material'
// import styles from './styles.module.css'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import styles from './timeLineStyle.module.scss'
export const TimeLineHeader = ({ title = 'Schedule' }) => {
	return (
		<>
			<div className={styles.pageHeader}>
				<Typography component="h1">{title}</Typography>
				<div className={styles.right}>
					<div className={styles.date}>
						<img
							src="/images/calendar_line.svg"
							alt="calendar_line.svg"
						/>
						<span> {new Date().toDateString()} </span>
					</div>
					{/* <ButtonCustom
						variant="default"
						size="lg"
						// onClick={() => setOpen(true)}
					>
						+ Add Event
					</ButtonCustom> */}
				</div>
			</div>
		</>
	)
}
